import Image from 'next/image'
import Link from 'next/link'

function Contact() {
  return (
    <div className="relative min-h-screen w-full overflow-hidden bg-gradient-to-br from-orange-50 via-yellow-50 to-white">
      <div className="container mx-auto flex min-h-screen flex-col justify-center px-4 py-12">
        <div className="mb-8 flex flex-col items-center">
          <Image src="/lingti-gd-logo.png" alt="灵缇互娱" width={80} height={80} className="mb-4" />
          <h1 className="mb-2 bg-gradient-to-r from-orange-400 via-yellow-400 to-orange-600 bg-clip-text text-3xl font-extrabold text-transparent">联系我们</h1>
          <p className="mb-2 bg-gradient-to-r from-pink-400 via-fuchsia-400 to-orange-600 bg-clip-text text-lg font-bold tracking-wider text-transparent drop-shadow-sm">
            灵缇赛事系统 · AI+体育综合服务商 · 软硬件体育装备制造商
          </p>
        </div>

        <div className="mx-auto flex w-full max-w-6xl flex-col gap-8 lg:flex-row">
          {/* 左侧：发牌机介绍 */}
          <div className="flex-1 rounded-2xl bg-white/80 p-8 shadow-xl backdrop-blur-md">
            <h2 className="mb-6 text-center text-2xl font-bold text-orange-500">灵缇牌三代复式发牌机</h2>

            <div className="mb-6 text-center">
              <Image src="/fushiji/fapaiji.png" alt="灵缇发牌机" width={300} height={300} className="mx-auto rounded-lg shadow-md" />
            </div>

            <div className="mb-4 text-center">
              <Link href="/baike/fapaiji" className="inline-block rounded-lg bg-brand px-4 py-2 font-medium text-white no-underline hover:bg-brand-dark">
                查看详细说明书 →
              </Link>
            </div>

            <div className="text-sm">
              <p className="mb-2 text-center text-gray-600">世界首款基于物联网、AI及云边协同的轻便型复式发牌机</p>
              <p className="mb-4 text-center text-gray-600">产地：中国·苏州</p>

              <div className="mb-4 flex flex-col items-center justify-center">
                <h5 className="mb-3 text-base font-semibold text-orange-600">核心特征：</h5>
                <ul className="space-y-2 text-gray-700">
                  <li>
                    <strong>智能操控：</strong>支持Web端、小程序、iOS、Android等多设备操控
                  </li>
                  <li>
                    <strong>轻巧便携：</strong>约20cm³，重量3-5千克，只手轻松携带
                  </li>
                  <li>
                    <strong>AI视觉识别：</strong>支持各类主流牌种，包括异型牌、带广告牌
                  </li>
                  <li>
                    <strong>模块化设计：</strong>可扩展3-108槽，耐用性强，易维护
                  </li>
                  <li>
                    <strong>安全保密：</strong>随机算子生成牌库，支持均衡牌力算法
                  </li>
                  <li>
                    <strong>系统联动：</strong>与灵缇赛事系统集成，支持复盘、牌力测算
                  </li>
                  <li>
                    <strong>集群操控：</strong>支持百台机器同时发牌，适用大型赛事
                  </li>
                </ul>
              </div>

              <div className="rounded-lg border border-red-200 bg-red-50 p-4">
                <p className="text-center text-lg font-bold text-red-600">🎉 惊爆价格：9999元</p>
                <p className="mt-1 text-center text-sm text-gray-600">另送灵缇赛事系统至尊VIP半年 + 一年维保服务</p>
              </div>
            </div>
          </div>

          {/* 右侧：联系我们 */}
          <div className="flex-1 rounded-2xl bg-white/80 p-8 shadow-xl backdrop-blur-md">
            <h2 className="mb-6 text-center text-2xl font-bold text-orange-500">联系方式</h2>

            <div className="mb-6">
              <h3 className="mb-4 text-xl font-bold text-orange-500">发牌机购买</h3>
              <p className="mb-6 text-gray-700">
                请咨询：<span className="font-semibold text-orange-600">冯先生</span>{' '}
                <span className="ml-2">
                  手机号：
                  <a href="tel:15599036698" className="underline">
                    15599036698
                  </a>
                </span>
              </p>
            </div>

            <div className="mb-6">
              <h3 className="mb-4 text-xl font-bold text-orange-500">商务合作</h3>
              <p className="mb-6 text-gray-700">
                请咨询：<span className="font-semibold text-orange-600">臧经理</span>{' '}
                <span className="ml-2">
                  手机号：
                  <a href="tel:15370036553" className="underline">
                    15370036553
                  </a>
                </span>
              </p>
            </div>

            <div className="mb-6 flex flex-col items-center gap-2">
              <span className="text-xs text-gray-400">我们将尽快回复您的咨询</span>
            </div>

            <div className="flex flex-col items-center">
              <span className="mb-2 text-center text-gray-500">搜索关注[灵缇互娱]官方微信公众号，获取更多资讯</span>
              <Image src="/wechat.png" alt="官方微信二维码" width={120} height={120} className="rounded-lg shadow" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Object.assign(Contact as any, {
  title: '联系灵缇互娱 · 球类赛事咨询 微信 lingtij',
  description: '匹克球/网球/羽毛球/乒乓球等球拍类赛事咨询、灵缇三代发牌机预定，请添加赛事主理人微信 lingtij，或访问公众号「灵缇互娱」。',
})

export default Contact
